export default "/app/global-wrapper-client/static/2ec397592f9322f765c7fd62f422ed14.woff";